module.exports = __webpack_public_path__ + "nc_static/media/edit-cards.a0b1c075.svg";